<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Course</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Course</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <div class="card-header">
            <h3 class="card-title" v-if="!is_edit">Create</h3>
            <h3 class="card-title" v-if="is_edit">Edit</h3>
            <div class="card-tools">
              <router-link class="btn btn-info" :to="{ name: 'CourseList' }"
                ><i class="fas fa-list"></i> List
              </router-link>
            </div>
          </div>
          <div class="card-body">
            <el-tabs>
              <el-tab-pane label="Course">
                <form method="POST" novalidate>
                  <div class="row">
                    <div class="col-8">
                      <div class="form-group required">
                        <label class="control-label"
                          >Course Title (English)</label
                        >
                        <input
                          type="text"
                          id="course_title"
                          name="course_title"
                          v-model="value.course_title"
                          @change="slug"
                          v-validate="'required'"
                          class="form-control course_title"
                          placeholder="Course Title (English)"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('course_title')"
                        >
                          {{ errors.first("course_title") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label"
                          >Course Title (Bangla)</label
                        >
                        <input
                          type="text"
                          id="course_title_bn"
                          name="course_title_bn"
                          v-model="value.course_title_bn"
                          class="form-control course_title_bn"
                          placeholder="Course Title (Bangla)"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('course_title_bn')"
                        >
                          {{ errors.first("course_title_bn") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label"
                          >Course Certificate Title</label
                        >
                        <input
                          type="text"
                          id="course_certificate_title"
                          name="course_certificate_title"
                          v-model="value.course_certificate_title"
                          v-validate="'required'"
                          class="form-control course_certificate_title"
                          placeholder="Course Certificate Title"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('course_certificate_title')"
                        >
                          {{ errors.first("course_certificate_title") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Slug/URL</label>
                        <input
                          type="text"
                          id="slug"
                          name="slug"
                          v-model="value.slug"
                          v-validate="'required'"
                          class="form-control slug"
                          placeholder="Slug/URL"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('slug')"
                        >
                          {{ errors.first("slug") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Summary (English)</label>
                        <textarea
                          id="course_summary"
                          name="course_summary"
                          v-model="value.course_summary"
                          v-validate="'required'"
                          class="form-control course_summary"
                          placeholder="Summary (English)"
                          rows="3"
                        ></textarea>
                        <div
                          class="help text-danger"
                          v-show="errors.has('course_summary')"
                        >
                          {{ errors.first("course_summary") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Summary (Bangla) </label>
                        <textarea
                          id="course_summary_bn"
                          name="course_summary_bn"
                          v-model="value.course_summary_bn"
                          class="form-control course_summary_bn"
                          placeholder="Summary (Bangla)"
                          rows="3"
                        ></textarea>
                        <div
                          class="help text-danger"
                          v-show="errors.has('course_summary_bn')"
                        >
                          {{ errors.first("course_summary_bn") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label"
                          >Description (English)</label
                        >
                        <ckeditor
                          id="description"
                          name="description"
                          v-model="value.description"
                          placeholder="Description"
                        ></ckeditor>
                      </div>
                      <div class="form-group">
                        <label class="control-label"
                          >Description (Bangla)</label
                        >
                        <ckeditor
                          id="description_bn"
                          name="description_bn"
                          v-model="value.description_bn"
                          placeholder="Description (Bangla)"
                        ></ckeditor>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Course Type</label>
                        <multiselect
                          name="course_type"
                          :options="course_types"
                          placeholder="Pick Course Type"
                          :searchable="true"
                          :multiple="false"
                          v-model="value.course_type"
                          v-bind:class="{
                            'has-error': errors.has('course_type'),
                          }"
                          class="course_type"
                        >
                        </multiselect>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Category</label>
                        <multiselect
                          id="category_id"
                          name="category_id"
                          :options="Object.keys(pre.category_id)"
                          :custom-label="(opt) => pre.category_id[opt]"
                          v-bind:class="{
                            'has-error': errors.has('category_id'),
                          }"
                          v-validate="'required'"
                          v-model="value.category_id"
                          class="category_id"
                          placeholder="Select Category"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                          @input="getSubcategory"
                        ></multiselect>
                        <div
                          class="help text-danger"
                          v-show="errors.has('category_id')"
                        >
                          {{ errors.first("category_id") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Sub Category</label>
                        <multiselect
                          id="sub_category_id"
                          name="sub_category_id"
                          :options="Object.keys(subcategories)"
                          :custom-label="(opt) => subcategories[opt]"
                          v-bind:class="{
                            'has-error': errors.has('sub_category_id'),
                          }"
                          v-validate="'required'"
                          v-model="value.sub_category_id"
                          class="sub_category_id"
                          placeholder="Select Sub-Category"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                        ></multiselect>
                        <div
                          class="help text-danger"
                          v-show="errors.has('sub_category_id')"
                        >
                          {{ errors.first("sub_category_id") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label">Instructor</label>
                        <el-select
                          v-model="value.instructor_id"
                          name="instructor_id"
                          placeholder="select question type"
                          v-validate="'required'"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="instructor in pre.instructors"
                            :key="instructor.id"
                            v-bind:class="{
                              'has-error': errors.has('instructor_id'),
                            }"
                            :label="instructor.name"
                            :value="instructor.id"
                          >
                          </el-option>
                        </el-select>
                        <div
                          class="help text-danger"
                          v-show="errors.has('instructor_id')"
                        >
                          {{ errors.first("instructor_id") }}
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>Course Image</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="course_image_path"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  id="course_image_path"
                                  name="course_image_path"
                                  class="custom-file-input"
                                  accept="image/png, image/jpeg, image/jpg"
                                  @change="selectFile($event, 'image')"
                                />
                                <label
                                  class="custom-file-label"
                                  for="course_image_path"
                                  >Choose file</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-if="fileName.image">
                            <img
                              alt="preview image"
                              v-if="value.course_image_path"
                              :src="value.course_image_path"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                            {{ fileName.image }}
                            &nbsp;
                            <i
                              class="fas fa-window-close"
                              @click="removeFile('image')"
                            ></i>
                          </div>
                        </div>
                        <span class="help text-info text-xs"
                          >Supported mimes: jpeg, jpg, png</span
                        >
                        <br />
                        <div
                          class="help text-danger"
                          v-show="errors.has('course_image_path')"
                        >
                          {{ errors.first("course_image_path") }}
                        </div>
                      </div>
                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>Intro Video</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="file_path"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  id="intro_video_path"
                                  name="intro_video_path"
                                  class="custom-file-input"
                                  accept="video/mp4"
                                  @change="uploadFile($event)"
                                />
                                <label
                                  class="custom-file-label"
                                  for="intro_video_path"
                                  >Choose file</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-if="fileName.video">
                            {{ fileName.video }}
                            &nbsp;
                            <i
                              class="fas fa-window-close"
                              @click="removeFile('video')"
                            ></i>
                          </div>
                        </div>
                        <span class="help text-info text-xs"
                          >Supported mimes: mp4</span
                        >
                        <br />
                        <div
                          class="help text-danger"
                          v-show="errors.has('intro_video_path')"
                        >
                          {{ errors.first("intro_video_path") }}
                        </div>
                      </div>
                      <!-- <div class="form-group">
                        <label class="control-label">Keyword</label>
                        <input
                          type="text"
                          id="keyword"
                          name="keyword"
                          v-model="value.keyword"
                          class="form-control keyword"
                          placeholder="Keyword"
                        />
                      </div> -->
                      <div class="form-group">
                        <label class="control-label">Youtube Url</label>
                        <input
                          type="text"
                          id="youtube_url"
                          name="youtube_url"
                          v-bind:class="{
                            'has-error': errors.has('youtube_url'),
                          }"
                          v-model="value.youtube_url"
                          class="form-control youtube_url"
                          placeholder="Youtube Url"
                        />
                      </div>
                      <div class="form-group">
                        <label class="control-label">Youtube Video Id</label>
                        <input
                          type="text"
                          id="youtube_video_id"
                          name="youtube_video_id"
                          v-bind:class="{
                            'has-error': errors.has('youtube_video_id'),
                          }"
                          v-model="value.youtube_video_id"
                          class="form-control youtube_video_id"
                          placeholder="Youtube Video Id"
                        />
                      </div>
                      <div class="form-group">
                        <label class="control-label">Tag</label>
                        <multiselect
                          id="tag"
                          name="tag"
                          :options="Object.values(pre.tag)"
                          :custom-label="(opt) => opt"
                          v-bind:class="{ 'has-error': errors.has('tag') }"
                          v-model="selected_tags"
                          class="tag"
                          :multiple="true"
                          placeholder="Select Tag"
                          :searchable="true"
                          :show-labels="false"
                        ></multiselect>
                      </div>
                      <div class="col-md-12">
                        <h4 class="site-heading my-3">
                          <span>Certificate Signature</span>
                        </h4>
                      </div>
                      <div class="form-group col-md-12">
                        <label for="file_path"></label>
                        <div class="row align-items-center">
                          <div class="col-4">
                            <div class="input-group">
                              <div class="custom-file">
                                <input
                                  type="file"
                                  id="certificate_signature"
                                  name="certificate_signature"
                                  class="custom-file-input"
                                  accept="image/png, image/jpeg, image/jpg"
                                  @change="selectFile($event, 'signature')"
                                />
                                <label
                                  class="custom-file-label"
                                  for="certificate_signature"
                                  >Choose file</label
                                >
                              </div>
                            </div>
                          </div>
                          <div class="form-group" v-if="fileName.signature">
                            <img
                              alt="preview image"
                              v-if="value.certificate_signature"
                              :src="value.certificate_signature"
                              width="100"
                              height="100"
                              class="img-circle"
                            />
                            {{ fileName.signature }}
                            &nbsp;
                            <i
                              class="fas fa-window-close"
                              @click="removeFile('signature')"
                            ></i>
                          </div>
                        </div>
                        <span class="help text-info text-xs"
                          >Supported mimes: jpeg, jpg, png</span
                        >
                        <br />
                        <div
                          class="help text-danger"
                          v-show="errors.has('certificate_signature')"
                        >
                          {{ errors.first("certificate_signature") }}
                        </div>
                      </div>
                      <div class="form-group required">
                        <label class="control-label"
                          >Course Duration(In Minute)</label
                        >
                        <input
                          type="number"
                          id="course_duration"
                          name="course_duration"
                          v-model="value.course_duration"
                          v-validate="'required'"
                          min="1"
                          class="form-control course_duration"
                          placeholder="Course Duration(In Minute)"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('course_duration')"
                        >
                          {{ errors.first("course_duration") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="control-label">Display Order</label>
                        <input
                          type="number"
                          min="0"
                          id="display_order"
                          name="display_order"
                          v-model="value.display_order"
                          class="form-control display_order"
                          placeholder="Display Order"
                        />
                      </div>
                      <div class="form-group">
                        <label class="control-label">Difficulty Level</label>
                        <div class="form-group">
                          <el-select
                            v-model="value.difficulty_level"
                            name="difficulty_level"
                            placeholder="select difficulty level"
                            style="width: 100%"
                          >
                            <el-option
                              v-for="item in [
                                { value: 'basic', label: 'Basic' },
                                {
                                  value: 'intermediate',
                                  label: 'Intermediate',
                                },
                                { value: 'advanced', label: 'Advanced' },
                              ]"
                              :key="item.value"
                              v-bind:class="{
                                'has-error': errors.has('difficulty_level'),
                              }"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                          <div
                            class="help text-danger"
                            v-show="errors.has('difficulty_level')"
                          >
                            {{ errors.first("difficulty_level") }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group required" v-if="!is_edit">
                        <label class="control-label">Default Price</label>
                        <input
                          type="number"
                          min="0"
                          id="price"
                          name="price"
                          v-model="value.price"
                          v-validate="'required'"
                          class="form-control price"
                          placeholder="Price"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('price')"
                        >
                          {{ errors.first("price") }}
                        </div>
                      </div>
                      <!--<div class="form-group">
                        <label class="control-label"
                          >Commission Configuration Id</label
                        >
                        <input
                          type="text"
                          id="commission_configuration_id"
                          name="commission_configuration_id"
                          v-model="value.commission_configuration_id"
                          class="form-control commission_configuration_id"
                          placeholder="Commission Configuration Id"
                        />
                      </div>
                      <div class="form-group">
                        <label class="control-label">Discount Expire Date</label>
                        <div class="clearfix"></div>
                        <date-picker
                          type="date"
                          input-class="form-control"
                          v-model="value.commission_expire_date"
                          lang="en"
                          format="YYYY-MM-DD"
                          value-type="YYYY-MM-DD"
                        ></date-picker>
                      </div>-->
                      <div class="form-group">
                        <label class="control-label">Related Courses</label>
                        <multiselect
                          id="related_courses"
                          name="related_courses"
                          :options="Object.keys(pre.related_courses)"
                          :custom-label="(opt) => pre.related_courses[opt]"
                          v-bind:class="{
                            'has-error': errors.has('related_courses'),
                          }"
                          :multiple="true"
                          v-model="similar_courses"
                          class="related_courses"
                          placeholder="Select Related Course"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                        ></multiselect>
                      </div>
                      <div class="form-group">
                        <div class="custom-control custom-checkbox">
                          <input
                            class="custom-control-input"
                            v-bind:class="{
                              'has-error': errors.has('is_featured'),
                            }"
                            type="checkbox"
                            :id="'is_featured'"
                            name="is_featured"
                            v-model="value.is_featured"
                          />
                          <label
                            :for="'is_featured'"
                            class="custom-control-label"
                            >Is Featured ?</label
                          >
                        </div>
                        <div
                          class="help text-danger"
                          v-show="errors.has('is_featured')"
                        >
                          {{ errors.first("is_featured") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="custom-control custom-checkbox">
                          <input
                            class="custom-control-input"
                            v-bind:class="{
                              'has-error': errors.has('is_published'),
                            }"
                            type="checkbox"
                            :id="'is_published'"
                            name="is_published"
                            v-model="value.is_published"
                          />
                          <label
                            :for="'is_published'"
                            class="custom-control-label"
                            >Is Published ?</label
                          >
                        </div>
                        <div
                          class="help text-danger"
                          v-show="errors.has('is_published')"
                        >
                          {{ errors.first("is_published") }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <add-feature
                    :features="value.features"
                    @updateFeatures="updateFeatures"
                  />
                  <div>
                    <button
                      type="submit"
                      v-if="!is_edit"
                      class="btn btn-primary"
                      @click.prevent="handleSubmission()"
                    >
                      Submit
                    </button>
                    <button
                      type="submit"
                      v-if="is_edit"
                      class="btn btn-primary"
                      @click.prevent="handleSubmission()"
                    >
                      Update
                    </button>
                  </div>
                </form>
              </el-tab-pane>
              <el-tab-pane label="SEO Meta" v-if="is_edit">
                <SEOMetaForm :meta="meta"></SEOMetaForm>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AddFeature from "./components/AddFeature.vue";
import SEOMetaForm from "./components/SEOMetaForm.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import CkEditorComponent from "../../../components/utils/CKEditorComponent.vue";

export default {
  name: "CourseForm",
  metaInfo: {
    title: "Course | Dotlines",
  },
  components: {
    DatePicker,
    AddFeature,
    CkEditorComponent,
    SEOMetaForm,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    subcategories: {},
    similar_courses: [],
    selected_tags: [],
    value: {
      tag: null,
      course_image_path: null,
      intro_video_path: null,
      certificate_signature: null,
      features: [],
      display_order: 999,
      course_duration: 1,
      price: 0,
      is_published: false,
      is_featured: false,
    },
    meta: {
      seoable_id: "",
      meta_title: "",
      meta_description: "",
      meta_keywords: "",
    },
    fileName: {
      image: null,
      video: null,
      signature: null,
    },
    pre: {
      category_id: {},
      instructors: [],
      tag: {},
      related_courses: {},
    },
    course_types: ["Course", "Quiz", "Content"],
  }),
  methods: {
    getSubcategory: function () {
      var that = this;
      that.is_loading = true;
      that.subcategories = {};
      axios
        .get("/sub-categories", {
          params: { category_id: that.value.category_id },
        })
        .then((response) => {
          var subcat = response.data.data;
          subcat.forEach((element) => {
            that.subcategories[element.id] = element.sub_category_name;
          });
        })
        .catch((error) => {
          resolve(error);
        })
        .finally(() => {
          that.is_loading = false;
        });
    },
    uploadFile: function (event) {
      let _this = this;
      _this.is_loading = true;
      let formData = new FormData();
      formData.append("video_file", event.target.files[0]);
      axios({
        method: "POST",
        url: "/file-upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          _this.value.intro_video_path = response.data.file_name;
          var filename = response.data.file_name
            ? response.data.file_name.split("videos/")
            : [];
          _this.fileName.video = filename.length > 0 ? filename[1] : "";
        })
        .catch((errors) => {
          console.log(errors);
        })
        .finally(() => {
          _this.is_loading = false;
        });
    },
    selectFile: function (event, type) {
      this.is_loading = true;
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        switch (type) {
          case "image":
            this.value.course_image_path = reader.result;
            this.fileName.image = event.target.files[0].name;
            break;
          case "video":
            this.value.intro_video_path = reader.result;
            this.fileName.video = event.target.files[0].name;
            break;
          case "signature":
            this.value.certificate_signature = reader.result;
            this.fileName.signature = event.target.files[0].name;
            break;
        }
        this.is_loading = false;
      };
    },
    removeFile: function (type) {
      switch (type) {
        case "image":
          this.fileName.image = null;
          this.value.course_image_path = null;
          break;
        case "video":
          this.fileName.video = null;
          this.value.intro_video_path = null;
          break;
        case "signature":
          this.fileName.signature = null;
          this.value.certificate_signature = null;
          break;
      }
    },
    categoryIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/3")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    instructors: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/instructors")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    tagOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/5")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    relaredCourseOptions: function () {
      return axios.get("courses/related-courses");
    },
    handleSubmission() {
      let _this = this;
      // if (_this.value.tags) this.value.tag = _this.value.tags.toString();
      if (_this.similar_courses)
        _this.value.related_courses = _this.similar_courses.toString();
      if (_this.selected_tags) _this.value.tag = _this.selected_tags.toString();
      _this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/courses";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/courses/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "CourseList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              } else if (errors.response.status === 424) {
                _this.$toaster.error(errors.response.data.errors.message);
              } else {
                _this.$setErrorsFromResponse(errors.response.data);
                _this.$toaster.error(errors.response.data.message);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/courses/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    slug() {
      var title = this.value.course_title;
      this.value.slug = title.replace(/\s+/g, "-").toLowerCase();
      // return this.value.slug
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.categoryIdOptions().then((category_id) => {
        this.pre.category_id = category_id;
      });
      await this.instructors().then((instructors) => {
        this.pre.instructors = instructors;
      });
      await this.tagOptions().then((tag) => {
        this.pre.tag = tag;
      });

      await this.relaredCourseOptions()
        .then((response) => {
          this.pre.related_courses = response.data;
        })
        .catch((error) => {
          this.pre.related_courses = {};
        });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        this.getSubcategory();
        await this.getDetail(this.params.id).then((response) => {
          this.value = response.data;
          if (!_.isNull(response.data.meta_data)) {
            this.meta = response.data.meta_data;
          } else {
            this.meta.seoable_id = this.params.id;
          }
          this.selected_tags = this.value.tag ? this.value.tag.split(",") : [];
          this.similar_courses = this.value.related_courses
            ? this.value.related_courses.split(",")
            : [];
          this.value.course_image_path =
            this.API_ASSET_UPLOAD_URL +
            "learning/" +
            response.data.course_image_path;
          var filename = this.value.course_image_path
            ? this.value.course_image_path.split("images/")
            : [];
          this.fileName.image = filename.length > 0 ? filename[1] : "";

          this.value.intro_video_path = response.data.intro_video_path;
          var filename = this.value.intro_video_path
            ? this.value.intro_video_path.split("videos/")
            : [];
          this.fileName.video = filename.length > 0 ? filename[1] : "";

          this.value.certificate_signature =
            this.API_ASSET_UPLOAD_URL +
            "learning/" +
            response.data.certificate_signature;
          var filename = this.value.certificate_signature
            ? this.value.certificate_signature.split("files/")
            : [];
          this.fileName.signature = filename.length > 0 ? filename[1] : "";
        });
      }

      this.is_loading = false;
    },
    updateFeatures: function (value) {
      this.value.features = value;
    },
  },
  mounted() {
    this.initialize();
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
